export default {"src":"https://fishbrain.com/_next/static/media/newJersey.923f19bd.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};